import {DELETE_NEWS_ERROR, DELETE_NEWS_START, DELETE_NEWS_SUCCESS} from "../../types";

export default function delete_news(state, action) {
    switch (action.type) {
        case DELETE_NEWS_START:
            return {
                ...state,
                loading: true,
                error: null
            };
        case DELETE_NEWS_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null
            };
        case DELETE_NEWS_ERROR:
            return {
                ...state,
                loading: false,
                error: action.detail
            };
        default:
            return {...state};
    }
}
